<template>
    <div
        class="absolute opacity-0 transition-opacity duration-100 group-hover/menuItem:opacity-100">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 36 50"
            fill="none"
            width="36"
            height="50"
            :class="animationClasses">
            <path
                d="M29.6973 43.0894C29.6973 43.0894 24.5993 38.2965 26.3844 30.0884C28.1695 21.8803 34.7975 19.6375 34.7975 19.6375"
                stroke="#743FDA"
                stroke-width="2" />
            <path
                d="M17.8867 45.6375C17.8867 45.6375 13.2346 38.7949 15.7427 27.2622C18.2508 15.7294 25.3246 11.437 25.3246 11.437"
                stroke="#743FDA"
                stroke-width="2" />
            <path
                d="M6.83984 49.3754C6.83984 49.3754 1.64497 40.3227 5.09997 24.436C8.55497 8.54927 17.0403 2.47174 17.0403 2.47174"
                stroke="#743FDA"
                stroke-width="2" />
        </svg>
    </div>
</template>

<script setup lang="ts">
type productType = 'radioguide' | 'audioguide' | 'conference' | 'environment'

const props = defineProps({
    product: {
        type: String as PropType<productType>,
        required: true,
    },
    position: {
        type: String as PropType<'left' | 'right'>,
        required: true,
    },
})

const animationClasses = computed(() => {
    switch (props.product) {
        case 'radioguide': {
            return props.position === 'left'
                ? 'rotate-[-45deg] scale-75 group-hover/menuItem:animate-waves-radio-left'
                : 'rotate-[145deg] scale-75 group-hover/menuItem:animate-waves-radio-right'
        }
        case 'audioguide':
        case 'conference': {
            return props.position === 'left'
                ? 'rotate-[-25deg] group-hover/menuItem:animate-waves-audio-left'
                : 'rotate-[155deg] group-hover/menuItem:animate-waves-audio-right'
        }
        case 'environment': {
            return 'rotate-[140deg] group-hover/menuItem:animate-waves-environment'
        }
        default: {
            return ''
        }
    }
})
</script>
